import { TActions } from '../../types/actions';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../redux/reducers';
import { SET_TERMS_DURATION } from '../../actions/termsDurations';
import { ITermsDurationsState } from '../../types/reducers/termsDurations';

import { defaultState } from './defaultState';

export const termsDurations = (state: ITermsDurationsState = defaultState, action: TActions): ITermsDurationsState => {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS:
      return {
        durations: action.payload.termsDurations,
        durationInDays: 1,
      };

    case SET_TERMS_DURATION:
      return {
        ...state,
        durationInDays: action.payload,
      };

    default:
      return state;
  }
};
